"use client";

import { BadgeCheck } from "lucide-react";
import { useUi } from "@/components/ui/use-ui";

export function VerifiedBadge({ size = 22 }: { size?: number }) {
  const label = useUi().profile.verified;
  return (
    <span title={label} className="inline-flex">
      <BadgeCheck size={size} strokeWidth={2} className="fill-brand text-ink" aria-label={label} />
    </span>
  );
}
